module.exports = __webpack_public_path__ + "static/media/Artboard10.37324a41.png";